import React from 'react';
import { SvgIcon } from '@mui/material';

export default function SmallCheckIcon({
  sx = { width: { xs: 16, lg: 24 }, height: { xs: 16, lg: 24 } },
  ...props
}) {
  return (
    <SvgIcon viewBox="0 0 24 24" sx={sx} {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.208 0H6.804C2.736 0 0 2.856 0 7.104V16.908C0 21.144 2.736 24 6.804 24H17.208C21.276 24 24 21.144 24 16.908V7.104C24 2.856 21.276 0 17.208 0Z"
          fill="#29EDFF"
        />
        <path
          d="M11.2224 16.1259C10.9536 16.1259 10.6848 16.0179 10.4796 15.8007L7.63202 12.7869C7.22162 12.3526 7.22162 11.649 7.63202 11.2159C8.04242 10.7815 8.70602 10.7802 9.11642 11.2146L11.2224 13.4435L16.176 8.20077C16.5864 7.76641 17.25 7.76641 17.6604 8.20077C18.0708 8.63512 18.0708 9.33873 17.6604 9.77309L11.9652 15.8007C11.76 16.0179 11.4912 16.1259 11.2224 16.1259Z"
          fill="#4520AB"
        />
      </svg>
    </SvgIcon>
  );
}
